<template>
  <button
    :disabled="disabled"
    class="text-title-small group tab-content relative z-0 flex cursor-pointer flex-col items-center justify-center overflow-hidden whitespace-nowrap outline-none md:min-w-[144px] lg:grow-0"
    :class="[
      selected && 'text-primary',
      !selected && 'text-on-surface-variant',
      hasIconOrImage && 'h-16',
      !hasIconOrImage && 'h-12',
      !scrollable && 'grow',
      scrollable && 'grow-0',
    ]"
  >
    <BaseIcon v-if="icon" :filled="selected">{{ icon }}</BaseIcon>
    <img v-else-if="img" class="h-6 w-6" :src="img" alt="" />

    <div class="relative flex items-center overflow-hidden rounded-full px-4 py-1">
      <BaseStateLayer />
      <slot />
      <div
        v-if="badgeCount"
        class="bg-primary ml-2 flex h-4 min-w-4 items-center justify-center rounded-full"
      >
        <span class="text-label-small text-on-primary">
          {{ badgeCount }}
        </span>
      </div>
    </div>
  </button>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'
  import BaseIcon from '../icon/BaseIcon.vue'

  interface Props {
    selected: boolean
    scrollable?: boolean
    img?: string
    icon?: string
    disabled?: boolean
    badgeCount?: number
  }
  const props = defineProps<Props>()

  const hasIconOrImage = computed(() => props.icon || props.img)
</script>
